import { render, staticRenderFns } from "./OneyModal.vue?vue&type=template&id=2d2267b4&"
import script from "./OneyModal.vue?vue&type=script&lang=js&"
export * from "./OneyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports